function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoInput = require('../../../../lib/saito/ui/saito-input/saito-input');
var ChatPopupTemplate = require('./popup.template');
var ChatUserMenu = require('./../overlays/chat-user-menu');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var debounce = require('lodash/debounce');
var ChatPopup = /*#__PURE__*/function () {
  function ChatPopup(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ChatPopup);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.input = null; //new SaitoInput(this.app, this.mod, `#chat-popup-${this.group.id} .chat-footer`);
    this.manually_closed = false;
    this.is_rendered = false;
    this.group = null;
    this.is_scrolling = null;
    this.overlay = new SaitoOverlay(app, mod);
    this.dimensions = {};
    this.events_attached = false;
    this.callbacks = {};
    this.closeFn = null;
    this.hasCloseFn = false;
    this.historyEntryActive = false;
    this.visualViewport = null;
    this.visualViewportResizeHandler = null;
    this.visualViewportResizeFrame = null;
    app.connection.on('chat-remove-fetch-button-request', function (group_id) {
      var _this$group;
      if (((_this$group = _this.group) === null || _this$group === void 0 ? void 0 : _this$group.id) === group_id) {
        _this.no_older_messages = true;
        if (document.querySelector('#chat-popup-' + _this.group.id + ' #load-older-chats')) {
          document.querySelector('#chat-popup-' + _this.group.id + ' #load-older-chats').remove();
        }
      }
    });
    app.connection.on('chat-popup-scroll-top-request', function (group_id) {
      var _this$group2;
      if (((_this$group2 = _this.group) === null || _this$group2 === void 0 ? void 0 : _this$group2.id) === group_id) {
        var popup_qs = '#chat-popup-' + _this.group.id;
        if (document.querySelector(popup_qs + ' .chat-body')) {
          document.querySelector(popup_qs + ' .chat-body').scroll(0, 0);
        }
      }
    });
    app.connection.on('stun-data-channel-open', function (pkey) {
      var _this$group3;
      var target_id = _this.mod.createGroupIdFromMembers([pkey, _this.mod.publicKey]);
      if (target_id === ((_this$group3 = _this.group) === null || _this$group3 === void 0 ? void 0 : _this$group3.id)) {
        if (_this.is_rendered) {
          _this.forceRender();
        }
      }
    });
    app.connection.on('stun-data-channel-close', function (pkey) {
      var _this$group4;
      var target_id = _this.mod.createGroupIdFromMembers([pkey, _this.mod.publicKey]);
      if (target_id === ((_this$group4 = _this.group) === null || _this$group4 === void 0 ? void 0 : _this$group4.id)) {
        if (_this.is_rendered) {
          _this.forceRender();
        }
      }
    });
    app.connection.on('chat-popup-refresh-request', function (group) {
      if (_this.group.id == group.id) {
        var title = 'chat-group-' + _this.group.id;
        var dm = group.members.length == 2 && !(group !== null && group !== void 0 && group.member_ids);
        if (dm) {
          for (var i = 0; i < group.members.length; i++) {
            if (group.members[i] !== mod.publicKey) {
              dm_counterparty = group.members[i];
            }
          }
        }
        _this.app.browser.replaceElementById("<div id=\"chat-group-".concat(group.id, "\" class=\"chat-group").concat(dm ? ' saito-address' : '', "\" data-id=\"").concat(_this.app.browser.escapeHTML(dm ? dm_counterparty : group.name), "\">").concat(_this.app.browser.escapeHTML(group.name), "</div>"), title);
        if (_this.is_rendered) {
          _this.render();
        }
      }
    });
  }
  return _createClass(ChatPopup, [{
    key: "remove",
    value: function remove() {
      this.removeVisualViewportResizeHandler();
      var popup_qs = '#chat-popup-' + this.group.id;
      if (document.querySelector(popup_qs)) {
        document.querySelector(popup_qs).remove();
      }
      this.is_rendered = false;
      this.is_scrolling = null;
      this.events_attached = false;
      this.app.connection.emit('chat-manager-render-request');
    }
  }, {
    key: "setContainer",
    value: function setContainer() {
      var _document$querySelect, _this$group5;
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var nextContainer = container || '';
      if (this.container === nextContainer) {
        return;
      }
      this.removeVisualViewportResizeHandler();
      (_document$querySelect = document.querySelector("#chat-popup-".concat((_this$group5 = this.group) === null || _this$group5 === void 0 ? void 0 : _this$group5.id))) === null || _document$querySelect === void 0 || _document$querySelect.remove();
      this.container = nextContainer;
      this.is_rendered = false;
      this.is_scrolling = null;
      this.events_attached = false;
      if (this.input) {
        this.input.display = this.container ? 'medium' : 'small';
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this$group6;
      if (!((_this$group6 = this.group) !== null && _this$group6 !== void 0 && _this$group6.id)) {
        return;
      }
      var popup_qs = '#chat-popup-' + this.group.id;
      document.querySelectorAll('.chat-container').forEach(function (el) {
        el.classList.remove('active');
      });
      document.querySelector(popup_qs).classList.add('active');
    }
  }, {
    key: "attachVisualViewportResizeHandler",
    value: function attachVisualViewportResizeHandler(chatPopup) {
      var _this2 = this;
      if (this.container || !window.visualViewport) {
        return;
      }
      this.removeVisualViewportResizeHandler();
      this.visualViewport = window.visualViewport;
      this.visualViewportResizeHandler = function () {
        var keepAtBottom = _this2.is_scrolling === null;
        chatPopup.style.setProperty('--chat-viewport-height', "".concat(_this2.visualViewport.height, "px"));
        chatPopup.style.setProperty('--chat-viewport-top', "".concat(_this2.visualViewport.offsetTop, "px"));
        if (keepAtBottom) {
          window.cancelAnimationFrame(_this2.visualViewportResizeFrame);
          _this2.visualViewportResizeFrame = window.requestAnimationFrame(function () {
            var chatBody = chatPopup.querySelector('.chat-body');
            if (chatBody) {
              chatBody.scrollTop = chatBody.scrollHeight;
            }
            _this2.visualViewportResizeFrame = null;
          });
        }
      };
      this.visualViewportResizeHandler();
      this.visualViewport.addEventListener('resize', this.visualViewportResizeHandler);
      this.visualViewport.addEventListener('scroll', this.visualViewportResizeHandler);
    }
  }, {
    key: "removeVisualViewportResizeHandler",
    value: function removeVisualViewportResizeHandler() {
      if (this.visualViewportResizeFrame) {
        window.cancelAnimationFrame(this.visualViewportResizeFrame);
      }
      if (this.visualViewport && this.visualViewportResizeHandler) {
        this.visualViewport.removeEventListener('resize', this.visualViewportResizeHandler);
        this.visualViewport.removeEventListener('scroll', this.visualViewportResizeHandler);
      }
      this.visualViewport = null;
      this.visualViewportResizeHandler = null;
      this.visualViewportResizeFrame = null;
    }
  }, {
    key: "forceRender",
    value: function forceRender() {
      var popup_qs = '#chat-popup-' + this.group.id;
      var chatPopup = document.querySelector(popup_qs);
      if (!chatPopup || this.container) {
        this.render();
        return;
      }
      var active = chatPopup.classList.contains('active');
      var sizing = '';
      if (chatPopup.classList.contains('minimized')) {
        sizing = 'minimized';
      }
      if (chatPopup.classList.contains('maximized')) {
        sizing = 'maximized';
      }
      if (!sizing) {
        this.savePopupDimensions(chatPopup);
      }
      this.remove();
      this.render();
      chatPopup = document.querySelector(popup_qs);
      if (active) {
        chatPopup.classList.add('active');
      }
      if (sizing) {
        chatPopup.classList.add(sizing);
      } else {
        this.restorePopup(chatPopup);
      }
    }

    //
    // The chat popup has subcomponents, but only the body gets re-rendered
    //
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var this_self = this;
      //
      // exit if group unset
      //
      if (this.group == null) {
        return 0;
      }

      //
      // exit if manually minimized
      //
      if (this.manually_closed) {
        return 0;
      }
      this.app.connection.emit('chat-manager-opens-group', this.group);

      //
      // our query selector
      //
      var popup_id = 'chat-popup-' + this.group.id;
      var popup_qs = '#' + popup_id;
      if (!this.input) {
        var _this$group7;
        this.input = new SaitoInput(this.app, this.mod, "#chat-popup-".concat(this.group.id, " .chat-footer"), popup_id);
        if (this.group.name == this.mod.communityGroupName || (_this$group7 = this.group) !== null && _this$group7 !== void 0 && _this$group7.member_ids || this.group.members.length > 2) {
          this.input.enable_mentions = false;
        }
        if (this.container) {
          this.input.display = 'medium';
        } else {
          this.input.display = 'small';
        }
      }

      //
      // calculate some values to determine position on screen...
      //
      var x_offset = 0;
      var popups_on_page = 0;

      // Use the chat manager to locate the first popup
      var cm = document.querySelector('.chat-manager');
      if (document.getElementById('chat-manager-overlay')) {
        cm = null;
      }
      var l2r = false;
      if (cm) {
        var cm_stats = cm.getBoundingClientRect();
        x_offset = cm_stats.right - 360;
        if (cm_stats.left * 2 < window.innerWidth) {
          l2r = true;
        }
      } else {
        x_offset = window.innerWidth - 375;
      }

      // We want to stack multiple chat popups next to each other
      document.querySelectorAll('.chat-container').forEach(function (el) {
        popups_on_page++;
        var rect = el.getBoundingClientRect();
        if (l2r) {
          if (rect.left > x_offset) {
            x_offset = rect.left;
          }
        } else {
          if (rect.left < x_offset) {
            x_offset = rect.left;
          }
        }
      });

      //
      // insert or replace popup on page
      //
      if (document.querySelector(popup_qs)) {
        var html = "<div class=\"chat-body\">";

        //Temporarily disable this...
        //if (!this?.no_older_messages) {
        //	html += `<div id="load-older-chats" class="saito-chat-button" data-id="${this.group.id}">fetch earlier messages</div>`;
        //}

        html += this.mod.returnChatBody(this.group.id) + '</div>';
        this.app.browser.replaceElementBySelector(html, popup_qs + ' .chat-body');
        this.mod.renderLinks(this.group.id);
      } else {
        var _this$group8;
        if (this.container && !document.querySelector(this.container)) {
          console.warn('Chat popup has non-existent specified container');
          this.container = '';
        }
        if (this.container && document.querySelector('.chat-static')) {
          this.app.browser.replaceElementBySelector(ChatPopupTemplate(this.app, this.mod, this.group, this.container), '.chat-static');
        } else {
          this.app.browser.addElementToSelectorOrDom(ChatPopupTemplate(this.app, this.mod, this.group, this.container), this.container);
        }
        this.mod.renderLinks(this.group.id);
        if (popups_on_page) {
          if (l2r) {
            x_offset += 90;
          } else {
            x_offset -= 90;
          }
        }

        // Keep popup on screen
        x_offset = Math.min(window.innerWidth - 360, x_offset);
        x_offset = Math.max(0, x_offset);

        //
        // now set left-position of popup
        //
        if (!this.container /*&& popups_on_page > 0*/) {
          var obj = document.querySelector(popup_qs);
          obj.style.left = x_offset + 'px';
        }

        // add call icon, ignore if community chat
        var mods = this.app.modules.mods;
        if (this.group.name != this.mod.communityGroupName && this.group.members.length == 2 && !((_this$group8 = this.group) !== null && _this$group8 !== void 0 && _this$group8.member_ids)) {
          var _dm_counterparty;
          for (var i = 0; i < this.group.members.length; i++) {
            if (this.group.members[i] !== this.mod.publicKey) {
              _dm_counterparty = this.group.members[i];
            }
          }
          var index = 0;
          var _iterator = _createForOfIteratorHelper(mods),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var mod = _step.value;
              var item = mod.respondTo('chat-actions', {
                publicKey: _dm_counterparty
              });
              if (item instanceof Array) {
                item.forEach(function (j) {
                  var id = "chat_action_item_".concat(index);
                  this_self.callbacks[id] = j.callback;
                  this_self.addChatActionItem(j, id);
                  index++;
                });
              } else if (item != null) {
                var id = "chat_action_item_".concat(index);
                this_self.callbacks[id] = item.callback;
                this_self.addChatActionItem(item, id);
              }
              index++;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        if (document.querySelector(popup_qs + ' .chat-action-menu')) {
          document.querySelector(popup_qs + ' .chat-action-menu').onclick = function (e) {
            var chatMenu = new ChatUserMenu(_this3.app, _this3.mod, _this3.group);
            chatMenu.render();
          };
        }

        //
        // inputs
        //
        this.input.render(!this.app.browser.isMobileBrowser());
      }

      //
      // fancy scrolling!
      //
      var chatBody = document.querySelector(popup_qs + ' .chat-body');
      if (chatBody) {
        var new_render = !this.is_rendered;

        //console.info('*** CHAT render: ',this.group.unread,new_render);

        if (this.is_scrolling) {
          //console.info('CHAT render: keep position');
          chatBody.scroll({
            top: this.is_scrolling,
            left: 0
          });
          this.updateNotification(this.group.unread);
        } else {
          var _this$group9;
          var anchor = (_this$group9 = this.group) !== null && _this$group9 !== void 0 && _this$group9.last_read_message ? document.querySelector(popup_qs + ' .message-' + this.group.last_read_message) : null;
          if (anchor && new_render && this.group.unread > 2) {
            //console.info(	'CHAT render: Scroll to anchor -- ' +this.group.last_read_message);
            anchor.scrollIntoView(false);
            this.updateNotification(this.group.unread);
          } else {
            //console.info('CHAT render: scroll to bottom');
            chatBody.scroll(0, 1000000000);
          }
        }
      }

      //
      // attach events
      //
      this.attachEvents();
      this.is_rendered = true;
      return 1;
    }
  }, {
    key: "updateNotification",
    value: function updateNotification(count) {
      var popup_id = 'chat-popup-' + this.group.id;
      var popup_qs = '#' + popup_id;
      if (document.querySelector(popup_qs + ' .saito-notification-dot .new-message-count')) {
        var notification = document.querySelector(popup_qs + ' .saito-notification-dot .new-message-count');
        notification.innerText = count;
        if (count == 0) {
          document.querySelector(popup_qs + ' .saito-notification-dot').remove();
        }
      } else {
        if (count == 0) {
          return;
        }
        this.app.browser.addElementToSelector("<div class=\"saito-notification-dot\"><div class=\"new-message-count\">".concat(this.group.unread, "</div><i class=\"fa-solid fa-down-long\"></i></div>"), popup_qs);
      }

      //update notification counts in the chat manager
      this.app.connection.emit('chat-manager-render-request');
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var app = this.app;
      var mod = this.mod;
      var group_id = this.group.id;
      var header_id = 'chat-header-' + this.group.id;

      //
      // our query selector
      //
      var popup_id = 'chat-popup-' + this.group.id;
      var popup_qs = '#chat-popup-' + this.group.id;
      var resize_id = 'chat-resize-' + this.group.id;
      var header_qs = '#chat-header-' + this.group.id;
      var this_self = this;
      var chatPopup = document.querySelector(popup_qs);
      if (!chatPopup) {
        console.error('No Chat Popup to attach events to');
        return;
      }
      var addUser = chatPopup.querySelector('.chat-unknown-contact-add');
      if (addUser) {
        addUser.onclick = function (e) {
          e.stopPropagation();
          var publicKey = addUser.dataset.publickey;
          if (publicKey) {
            app.keychain.addKey(publicKey, {
              added: true
            });
          }
          var bar = chatPopup.querySelector('.chat-unknown-contact');
          if (bar) {
            bar.remove();
          }
        };
      }

      // add reply functionality
      document.querySelectorAll("".concat(popup_qs, " .saito-userline-reply .chat-reply")).forEach(function (el) {
        el.addEventListener('click', function (e) {
          var src_obj = el.parentElement.parentElement.parentElement;
          var quote = '';
          var _iterator2 = _createForOfIteratorHelper(el.parentElement.parentElement.childNodes),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var child = _step2.value;
              if (child.nodeType === 3) {
                quote += child.textContent.replace(/^\s+|\s+$/g, '<br>');
              }
              //We may want to also pull inner text from element nodes as long as they aren't the hidden buttons
              if (child.nodeType === 1 && child.nodeName !== 'BLOCKQUOTE') {
                quote += child.innerText.replace(/^\s+|\s+$/g, '<br>');
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (quote.length > 30) {
            quote = '...' + quote.slice(-30);
          }
          var quoteHTML = "<blockquote href=\"".concat(el.parentElement.dataset.href, "\">").concat(quote, "</blockquote>");
          _this4.input.insertQuote(quoteHTML, src_obj.dataset.id);
          _this4.input.focus(true);
        });
      });
      document.querySelectorAll("".concat(popup_qs, " .saito-userline-reply .chat-copy")).forEach(function (el) {
        el.addEventListener('click', function (e) {
          var icon_element = e.currentTarget.firstElementChild;
          if (icon_element) {
            icon_element.classList.toggle('fa-copy');
            icon_element.classList.toggle('fa-check');
            setTimeout(function () {
              icon_element.classList.toggle('fa-copy');
              icon_element.classList.toggle('fa-check');
            }, 800);
          }
          var parent = el.parentElement.parentElement;
          var text = '';
          var _iterator3 = _createForOfIteratorHelper(parent.childNodes),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var child = _step3.value;
              if (child.nodeType === 3) {
                text += child.textContent;
              }
              //We may want to also pull inner text from element nodes as long as they aren't the hidden buttons
              if (child.nodeType === 1) {
                if (child.classList.contains('saito-treated-link')) {
                  text += child.href;
                } else if (!child.classList.contains('saito-userline-reply') && child.nodeName !== 'BLOCKQUOTE') {
                  text += child.innerText;
                }
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          text = text.replace(/^\s+|\s+$/g, '');
          navigator.clipboard.writeText(text);
        });
      });
      document.querySelectorAll("".concat(popup_qs, " .saito-userline-reply .chat-like")).forEach(function (el) {
        el.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
            var parentElement, sig, target, newtx;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  parentElement = event.target.closest('.saito-userline-reply'); // Retrieve the 'data-id' attribute from the found parent element
                  sig = parentElement.getAttribute('data-id');
                  target = parentElement.closest('.saito-userline').getAttribute('data-id');
                  _context.n = 1;
                  return _this4.mod.createChatLikeTransaction(_this4.group, sig, target);
                case 1:
                  newtx = _context.v;
                  if (newtx) {
                    mod.hasSeenTransaction(newtx);
                    mod.receiveChatLikeTransaction(newtx);
                  }
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
      if (chatPopup.querySelector('.fix-me.fa-unlock')) {
        chatPopup.querySelector('.fix-me.fa-unlock').onclick = function (e) {
          _this4.app.connection.emit('encrypt-reset-key-exchange', e.currentTarget.dataset.id);
        };
      }

      //
      // Click on a block quote to see original message being replied to
      //
      document.querySelectorAll("".concat(popup_qs, " blockquote")).forEach(function (el) {
        el.onclick = function (e) {
          var href = el.getAttribute('href');
          var myAnchor = document.querySelector(popup_qs + ' #' + href);
          if (myAnchor) {
            myAnchor.scrollIntoView({
              block: 'end',
              inline: 'nearest',
              behavior: 'smooth'
            });
          }
        };
      });

      //
      // At top of chat body, check for older chat messages
      //
      if (document.querySelector(popup_qs + ' #load-older-chats')) {
        document.querySelector(popup_qs + ' #load-older-chats').onclick = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  _context2.n = 1;
                  return _this4.mod.getOlderTransactions(e.currentTarget.dataset.id);
                case 1:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }();
      }

      //
      // While scrolled up, new messages below... scroll to bottom
      //
      if (document.querySelector(popup_qs + ' .saito-notification-dot')) {
        document.querySelector(popup_qs + ' .saito-notification-dot').onclick = function (e) {
          if (chatPopup.classList.contains('minimized')) {
            _this4.restorePopup(chatPopup);
          }
          document.querySelector(popup_qs + ' .chat-body').lastElementChild.scrollIntoView({
            behavior: 'smooth'
          });
        };
      }

      //
      // Remove scroll notification dynamically
      //
      var myBody = document.querySelector(popup_qs + ' .chat-body');
      if (myBody && myBody !== null && myBody !== void 0 && myBody.lastElementChild) {
        var pollScrollHeight = function pollScrollHeight() {
          var lastChild = myBody.lastElementChild;
          if (lastChild.querySelector('.saito-user .saito-userline')) {
            lastChild = myBody.lastElementChild.lastElementChild.lastElementChild;
          }
          if (lastChild.getBoundingClientRect().top > myBody.getBoundingClientRect().bottom) {
            _this4.is_scrolling = myBody.scrollTop;
          } else {
            _this4.is_scrolling = null;
            _this4.group.unread = 0;
            _this4.updateNotification(0);
          }

          //Check position of new messages...
          var next_new = document.querySelector(popup_qs + ' .chat-body .new-message');
          while (next_new && next_new.getBoundingClientRect().top < myBody.getBoundingClientRect().bottom) {
            //the message has scrolled into view
            next_new.classList.remove('new-message');
            _this4.group.unread = Math.max(0, _this4.group.unread - 1);
            _this4.group.last_read_message = next_new.dataset.id;
            _this4.updateNotification(_this4.group.unread);
            next_new = document.querySelector(popup_qs + ' .chat-body .new-message');
          }
          _this4.mod.saveChatGroup(_this4.group);
        };
        pollScrollHeight();
        myBody.addEventListener('scroll', debounce(pollScrollHeight, 100));
      }

      //
      // Click images to view full size
      //
      document.querySelectorAll(".img-prev").forEach(function (img, key) {
        img.onclick = function (e) {
          e.preventDefault();
          var img = e.currentTarget;
          var src = img.getAttribute('src');
          if (!this_self.app.browser.isSafeMediaUrl(src)) {
            return;
          }
          this_self.overlay.show("<img class=\"chat-popup-img-enhanced\" src=\"".concat(this_self.app.browser.escapeHTML(src), "\" >"));
        };
      });

      /* 
        avoids re-adding of events to same element, to fix issues with resizing 
        The following events apply to the whole popup, its header or its footer, which
        don't get rerendered... 
      */
      if (this.events_attached == false) {
        this.events_attached = true;
      } else {
        return;
      }
      if (this.app.browser.isMobileBrowser() || window.innerWidth < 600) {
        this.attachVisualViewportResizeHandler(chatPopup);
        window.history.pushState('chat', '');
        this.historyEntryActive = true;
        this.closeFn = window.onpopstate;
        this.hasCloseFn = true;
        window.onpopstate = function (e) {
          _this4.historyEntryActive = false;
          _this4.close();
        };
      }
      if (this.group.name != this.mod.communityGroupName) {
        document.querySelectorAll('.chat-action-item').forEach(function (menu) {
          var id = menu.getAttribute('id');
          if (id && this_self.callbacks[id]) {
            var callback = this_self.callbacks[id];
            menu.onclick = function (e) {
              callback(app, id);
            };
          }
        });
      }
      if (!this.mod.browser_active && !this.app.browser.isMobileBrowser()) {
        //
        // make draggable and resizable, but no in mobile/main - page
        //
        this.app.browser.makeDraggable(popup_id, header_id, true);
        this.app.browser.makeResizeable(popup_qs, header_qs, group_id);
      }
      chatPopup.onmousedown = this.activate.bind(this);

      //
      // minimize
      var chat_bubble = document.querySelector("".concat(popup_qs, " .chat-header .chat-minimizer-icon"));
      var mximize_icon = document.querySelector("".concat(popup_qs, " .chat-header .chat-maximizer-icon"));
      if (chat_bubble && mximize_icon /*&& !this.mod.chat_manager_overlay*/) {
        chat_bubble.onclick = function (e) {
          if (chatPopup.classList.contains('minimized')) {
            _this4.restorePopup(chatPopup);
          } else {
            if (chatPopup.classList.contains('maximized')) {
              chatPopup.classList.remove('maximized');
            } else {
              //only update if not also maximized
              _this4.savePopupDimensions(chatPopup);
            }

            //Undo any drag styling
            chatPopup.style.top = '';
            chatPopup.style.left = '';

            //Return to default bottom=0 from css
            chatPopup.style.bottom = '';

            //Undo any manual resizing
            chatPopup.style.height = '';
            if (parseInt(window.getComputedStyle(chatPopup).width) > 360) {
              chatPopup.style.width = '';
            }
            chatPopup.classList.add('minimized');
            chatPopup.classList.remove('active');
            chatPopup.querySelector('.resize-icon').style.display = 'none';
          }
        };

        //
        // maximize

        mximize_icon.onclick = function (e) {
          if (chatPopup.classList.contains('maximized')) {
            _this4.restorePopup(chatPopup);
          } else {
            if (chatPopup.classList.contains('minimized')) {
              chatPopup.classList.remove('minimized');
            } else {
              _this4.savePopupDimensions(chatPopup);
            }

            //Undo any drag styling
            chatPopup.style.top = '';
            chatPopup.style.left = '';
            chatPopup.style.width = '750px';
            chatPopup.style.height = window.innerHeight + 'px';

            //Return to default bottom=0 from css
            chatPopup.style.bottom = '';

            // decide to maximize to left or right
            if (_this4.dimensions.left < Math.floor(window.innerWidth / 2)) {
              chatPopup.style.right = window.innerWidth - 750 + 'px';
            } else {
              chatPopup.style.right = '0px';
            }
            chatPopup.classList.add('maximized');
            chatPopup.querySelector('.resize-icon').style.display = 'none';
          }
        };
      }

      //
      // close
      //
      document.querySelector("".concat(popup_qs, " .chat-header .chat-container-close")).onclick = function (e) {
        _this4.close();
      };
      document.querySelector("".concat(popup_qs, " .chat-header .chat-mobile-back")).onclick = function (e) {
        if (_this4.historyEntryActive) {
          window.history.back();
        } else {
          _this4.close();
        }
      };

      //
      // submit
      //
      this.input.callbackOnReturn = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(message) {
          var new_msg, newtx;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                if (!(message.trim() == "".concat(_this4.input.quote))) {
                  _context3.n = 1;
                  break;
                }
                console.log('Reply with no content');
                return _context3.a(2);
              case 1:
                new_msg = message.replaceAll('&nbsp;', ' ').replaceAll('<br>', ' ');
                if (!(new_msg.trim() == '')) {
                  _context3.n = 2;
                  break;
                }
                return _context3.a(2);
              case 2:
                _context3.n = 3;
                return mod.createChatTransaction(group_id, message, _this4.input.getMentions());
              case 3:
                newtx = _context3.v;
                _this4.input.clear();
                if (!newtx) {
                  _context3.n = 4;
                  break;
                }
                _context3.n = 4;
                return mod.receiveChatTransaction(newtx);
              case 4:
                if (document.querySelector(popup_qs + ' .chat-body')) {
                  _this4.is_scrolling = null;
                  document.querySelector(popup_qs + ' .chat-body').scroll(0, 1000000000);
                }
              case 5:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }();
      this.input.callbackOnUpload = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(result) {
          var confirm,
            imageUrl,
            response,
            blob,
            resizedImageUrl,
            img,
            _args5 = arguments;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                confirm = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
                if (!(typeof result === 'string')) {
                  _context5.n = 5;
                  break;
                }
                if (result.includes('giphy.gif')) {
                  _context5.n = 3;
                  break;
                }
                _context5.n = 1;
                return fetch(result);
              case 1:
                response = _context5.v;
                _context5.n = 2;
                return response.blob();
              case 2:
                blob = _context5.v;
                imageUrl = URL.createObjectURL(blob);
                _context5.n = 4;
                break;
              case 3:
                imageUrl = result;
              case 4:
                _context5.n = 7;
                break;
              case 5:
                if (!(result instanceof File)) {
                  _context5.n = 6;
                  break;
                }
                imageUrl = URL.createObjectURL(result);
                _context5.n = 7;
                break;
              case 6:
                throw new Error('Invalid filesrc type');
              case 7:
                resizedImageUrl = imageUrl;
                if (imageUrl.includes('giphy.gif')) {
                  _context5.n = 9;
                  break;
                }
                console.log('************* Resize Image!');
                _context5.n = 8;
                return app.browser.resizeImg(imageUrl);
              case 8:
                resizedImageUrl = _context5.v;
              case 9:
                img = document.createElement('img');
                img.classList.add('img-prev');
                img.src = resizedImageUrl;
                _this4.overlay.show("<div class=\"chat-popup-img-overlay-box\">\n\t\t\t\t   <img class=\"chat-popup-img-enhanced\" src=\"".concat(resizedImageUrl, "\" >\n\t\t\t\t   <button id=\"photo-preview-upload\" class=\"saito-button-primary\">Upload</button>\n\t\t\t\t</div>"));
                document.getElementById('photo-preview-upload').onclick = /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
                    var msg, typed_msg;
                    return _regenerator().w(function (_context4) {
                      while (1) switch (_context4.n) {
                        case 0:
                          _this4.overlay.close();
                          msg = img.outerHTML;
                          typed_msg = _this4.input.getInput();
                          _context4.n = 1;
                          return _this4.input.callbackOnReturn(msg);
                        case 1:
                          _this4.input.setInput(typed_msg);
                        case 2:
                          return _context4.a(2);
                      }
                    }, _callee4);
                  }));
                  return function (_x5) {
                    return _ref5.apply(this, arguments);
                  };
                }();
                document.getElementById('photo-preview-upload').focus();
              case 10:
                return _context5.a(2);
            }
          }, _callee5);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }();

      //
      // submit (button)
      //
      document.querySelector("".concat(popup_qs, " .chat-footer .chat-input-submit")).onclick = function (e) {
        _this4.input.callbackOnReturn(_this4.input.getInput(false));
      };

      //
      // drag and drop images into chat window
      //

      app.browser.addDragAndDropFileUploadToElement(popup_id, this.input.callbackOnUpload, false); // false = no drag-and-drop image click
    }
  }, {
    key: "addChatActionItem",
    value: function addChatActionItem(item, id) {
      var popup_qs = '#chat-popup-' + this.group.id;
      var html = "<div id=\"".concat(id, "\" class=\"chat-action-item\" title=\"").concat(item.text, "\">\n\t\t\t\t<i class=\"").concat(item.icon, "\"></i>\n\t\t\t</div>");
      this.app.browser.prependElementToSelector(html, "".concat(popup_qs, " .chat-actions"));
    }
  }, {
    key: "restorePopup",
    value: function restorePopup(chatPopup) {
      chatPopup.classList.remove('minimized');
      chatPopup.classList.remove('maximized');
      this.activate();

      //console.log("Restore: ", this.dimensions);
      if (Object.keys(this.dimensions).length > 0) {
        chatPopup.style.width = this.dimensions.width + 'px';
        chatPopup.style.height = this.dimensions.height + 'px';
        if (chatPopup.style.left) {
          //Moved after minimized or maximized
          chatPopup.style.left = '';
          chatPopup.style.top = '';
        }
        chatPopup.style.bottom = this.dimensions.bottom + 'px';
        chatPopup.style.right = this.dimensions.right + 'px';
      }
      this.dimensions = {};
      if (chatPopup.querySelector('.resize-icon')) {
        chatPopup.querySelector('.resize-icon').style.display = 'block';
      }
    }
  }, {
    key: "savePopupDimensions",
    value: function savePopupDimensions(chatPopup) {
      //
      // You need to copy into a new object!!!!
      //
      var obj = chatPopup.getBoundingClientRect();
      this.dimensions.width = obj.width;
      this.dimensions.height = obj.height;
      this.dimensions.left = obj.left;
      this.dimensions.top = obj.top;
      this.dimensions.bottom = window.innerHeight - obj.bottom;
      this.dimensions.right = window.innerWidth - obj.right;

      //console.log("Save: ", this.dimensions);

      if (chatPopup.style.top) {
        // Will revert to bottom/right coordinates for animation to be anchored
        chatPopup.style.bottom = this.dimensions.bottom + 'px';
        chatPopup.style.right = this.dimensions.right + 'px';
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.manually_closed = true;
      this.historyEntryActive = false;
      this.remove();
      this.app.storage.saveOptions();
      if (this.hasCloseFn) {
        window.onpopstate = this.closeFn;
        this.closeFn = null;
        this.hasCloseFn = false;
      }
    }
  }]);
}();
module.exports = ChatPopup;